<template>
  <header>
    <div class="container-sarah">
      <main-menu />
    </div>
  </header>
</template>

<script>
import MainMenu from '@/components/shared/header/MainMenu'
export default {
  components: {
    MainMenu
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
header {
  box-shadow: -0px 0px 14px 0px $neutral-color-4;
  position: relative;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 200;

  background-color: var(--bg-color-primary);
}
</style>
